module.exports = __webpack_public_path__ + "static/media/candy-bubble.620df73b.jpg";